export default __webpack_public_path__ + "static/media/mphasis.6970323b.png";